import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';

import { FindSlideByTargetAndReferenceCacheGQL, FindSlidesByTargetCacheGQL, SlidesType } from '@sifca-monorepo/ecommerce-generator';
import { AppCookieService } from '@diktup/frontend/helpers';

@Injectable({
  providedIn: 'root',
})
export class SlidesService {
  // Private
  private slides: BehaviorSubject<SlidesType[] | null> = new BehaviorSubject(null);
  private newsletter: BehaviorSubject<SlidesType | null> = new BehaviorSubject(null);

  /**
   * Constructor
   */
  constructor(
    private cookiesService: AppCookieService,
    private findSlidesByTargetGQL: FindSlidesByTargetCacheGQL,
    private findSlidesByTargetAndReferenceGQL: FindSlideByTargetAndReferenceCacheGQL,
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for slides
   */
  get slides$(): Observable<SlidesType[]> {
    return this.slides.asObservable();
  }

  get newsletter$(): Observable<SlidesType> {
    return this.newsletter.asObservable();
  }

  getSlides(pos: string): Observable<SlidesType[]> {
    return this.findSlidesByTargetGQL
      .fetch({
        ...(localStorage.getItem('elvklang') && localStorage.getItem('elvklang') !== 'none' ? { language: localStorage.getItem('elvklang') } : {}),
        target: { pos },
      })
      .pipe(
        map(({ data }: any) => {
          if (data) {
            this.slides.next(data.findSlidesByTargetCache);
            this.newsletter.next(data.findSlidesByTargetCache.filter(slide => slide.reference === 'newsletter')[0]);
            return data.findSlidesByTargetCache;
          }
        }),
      );
  }

  getSlidesByReference(pos: string, reference: string): Observable<SlidesType[]> {
    return this.findSlidesByTargetAndReferenceGQL
      .fetch({
        reference,
        target: { pos },
      })
      .pipe(
        map((response: any) => {
          return response.data.findSlideByTargetAndReferenceCache;
        }),
      );
  }
}
